import EditorWidget from './EditorWidget';

export default EditorWidget;
